<template>
  <section :id="data?.anchor_id ? data.anchor_id : null" class="similarAccommodations defaultSectionPaddings">
    <div class="container">
      <h2 v-text="data.title" />

      <SimilarAccommodationsSlider :locations="locations" :flickityOptions="flickityOptions" />
    </div>
  </section>
</template>

<script setup>
  const props = defineProps({
    data: {},
  });

  const { accommodationsData } = useSetup();

  const flickityOptions = {
    pageDots: false,
    prevNextButtons: false,
    contain: true,
    cellAlign: 'left',
  };

  const locations = computed(() => {
    let results = [];
    for (let item of props.data.items) {
      if (accommodationsData.value[item.accommodation]) results.push(accommodationsData.value[item.accommodation])
    }
    return results;
  })
</script>

<style lang="scss">
  // @import url('@/assets/styles/components/blocks/_similarAccommodations.scss');
</style>